import { nameof } from "ts-simple-nameof";
import styles from "./InventoryCategoryFormFields.module.scss";
import { IInventoryCategoryFormModel } from "../models/inventoryNomenclatureModels";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultFormEmojiField } from "../../../../common/components/forms/inputs/emojiField/DefaultFormEmojiField";

/**
 * Fields for the inventory category dialog. A category always has a
 * required emoji that every product in the category inherits.
 */
export const InventoryCategoryFormFields = () => {
  return (
    <div className={styles.root}>
      <DefaultInputField
        name={nameof<IInventoryCategoryFormModel>((x) => x.name)}
        label="Име на категория"
        placeholder="Напитки"
        required
      />

      <DefaultFormEmojiField
        name={nameof<IInventoryCategoryFormModel>((x) => x.emoji)}
        label="Emoji"
        placeholder="Изберете emoji"
        required
      />
    </div>
  );
};
